import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useDebouncedCallback } from "@evergis/react";

import { Style } from "../../../ducks/style/style";
import { useArgsSelector } from "../../../hooks/useArgsSelector";
import { usePostgresLayer } from "../../../hooks/layer/usePostgresLayer";
import {
  changeLayerTempStyle,
  createLayerTempStyle,
  updateLayerTempStyle,
} from "../../../ducks/layerTempStyle/layerTempStyle";
import { getLayerTempStyle } from "../../../ducks/layerTempStyle/selectors";

export const useRasterTempStyle = (layerName: string): { style: Style; setStyle: (style: Style) => void } => {
  const dispatch = useDispatch();
  const { style: storeTempStyle } = useArgsSelector(getLayerTempStyle, layerName) || {};
  const debounceUpdateTempStyle = useDebouncedCallback(300);
  const { postgresLayer, loading } = usePostgresLayer(layerName, { waitInput: true });

  useEffect(() => {
    if (postgresLayer && !loading && !storeTempStyle) {
      dispatch(createLayerTempStyle(postgresLayer));
    }
  }, [postgresLayer, loading, storeTempStyle, dispatch]);

  const setStyle = useCallback(
    (style: Style) => {
      dispatch(
        changeLayerTempStyle({
          layerName,
          style,
        }),
      );

      debounceUpdateTempStyle(() => {
        dispatch(updateLayerTempStyle({ layerName, style }));
      });
    },
    [layerName],
  );

  return { style: storeTempStyle, setStyle };
};
